import { useContext, useState } from 'react';
import FormField from '../../components/FormField/FormField';
import StepHeader from '../../components/Wizard/StepHeader';
import { clearSpaces, maskClearSpecialCharacters } from '../../utils/Masks';
import Button from '../../components/Button/Button';
import ButtonLabel from '../../components/Button/ButtonLabel';

import Alert from '../../components/Alert';
import { SignUpContext } from '../../data/SignUp/SignUpContext';
import RedirectSignIn from './RedirectSignIn';
import FormFieldToggle from '../../components/FormField/FormFieldToggle';

export interface SignUpSocialNameProps {
  allowSkipStep?: boolean;
  updateData?: boolean;
  previousPath?: number | null;
  nextPath?: number | null;
  handleChangeStep(e: number): void;
  context: any;
}

export default function SignUpSocialName({
  nextPath,
  previousPath,
  handleChangeStep,
  context
}: SignUpSocialNameProps) {
  const [errorRequest, setErrorRequest] = useState('');

  const { register, trigger, errors, touchedFields, setValue, watch } =
    useContext(SignUpContext);

  const hasSocialName = watch('hasSocialName');
  const prefersSocial = watch('prefersSocial');
  const noSocialName = !hasSocialName;

  function controlBackPage() {
    if (previousPath == 0 || previousPath) handleChangeStep(previousPath);
  }

  window.onpopstate = () => {
    controlBackPage();
  };

  async function checkValidateFields() {
    if (noSocialName) return true;

    const validateFullName = await trigger(['socialName']);

    return new Promise((resolve) => {
      const fixedFieldsValidated = validateFullName;
      resolve(fixedFieldsValidated);
    });
  }

  function handleToggleNoSocialName(status: boolean) {
    if (status) {
      setValue('hasSocialName', false, { shouldValidate: true });
      setValue('socialName', '', { shouldValidate: true });
      setValue('prefersSocial', false, { shouldValidate: true });
    } else {
      setValue('hasSocialName', true, { shouldValidate: true });
    }
  }

  function handleTogglePrefersSocial(status: boolean) {
    setValue('prefersSocial', status, { shouldValidate: true });
  }

  function nextStep() {
    checkValidateFields().then((response) => {
      if (response && nextPath) {
        handleChangeStep(nextPath);
      }
    });
  }

  return (
    <div className="card__section">
      <div className="card__top">
        <StepHeader
          title="Outra coisa..."
          description="Caso você possua um nome social, nos informe abaixo. Você também pode torná-lo preferêncial."
        />

        <div className="form-group" style={{ gap: 16 }}>
          <Alert
            message={errorRequest}
            errors={errors}
            onClose={setErrorRequest}
          />

          <FormField
            name="socialName"
            label="qual seu nome social?"
            type="text"
            error={errors}
            touchedFields={touchedFields}
            onKeyUp={maskClearSpecialCharacters}
            onBlur={clearSpaces}
            register={register('socialName')}
            placeholder="seu nome social completo"
            iconPrefix="personId"
          />

          <div className="flex" style={{ gap: 12, alignItems: 'center' }}>
            <FormFieldToggle
              value={'noSocialName'}
              checked={noSocialName}
              callbackChange={handleToggleNoSocialName}
            />
            <p
              style={{
                color: 'var(--Text-colors-Text-Tertiary)',
                fontSize: 14
              }}
            >
              Não tenho um nome social
            </p>
          </div>

          {!noSocialName && (
            <div className="flex" style={{ gap: 12, alignItems: 'center' }}>
              <FormFieldToggle
                value={'prefersSocial'}
                checked={!!prefersSocial}
                callbackChange={handleTogglePrefersSocial}
              />{' '}
              <p
                style={{
                  color: 'var(--Text-colors-Text-Tertiary)',
                  fontSize: 14
                }}
              >
                Tornar meu nome social como preferêncial
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="button-group">
        <Button
          id="signup-socialname"
          full
          onClick={nextStep}
          disabled={!!errors?.socialName}
        >
          <ButtonLabel>continuar</ButtonLabel>
        </Button>

        <Button
          customColors="btn-ghost"
          aria-label="Voltar"
          onClick={controlBackPage}
        >
          <ButtonLabel>Voltar</ButtonLabel>
        </Button>

        <RedirectSignIn context={context} />
      </div>
    </div>
  );
}
